<template>
  <ul class="checklist checklist--spacing">
    <li v-show="!isOpera || venvironment.includes(item)" v-for="(item,key) in environment" class="checklist__item" :class="{'checklist__item--not-available': !venvironment.includes(item) }" :key="key">{{ item }}</li>
  </ul>
</template>

<script>

export default {
    data() {
        return {
           venvironment : ''
        } 
    },
    props: ['environment','venueenvironment'],
    computed: {
        notinlist() {
            return true;     
        },
        isOpera() {
            return this.$store.state.isOpera;
        },
    },
    watch: {
        venueenvironment: function(value) {
         this.venvironment = value;
        }
    }
}
</script>

